import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../../../../localization/react'
import { MatchLevel } from '../../../Match.types'
import { levelDescriptionTranslation, levelTranslation } from '../MatchSettings.constants'

interface Props {
  level: MatchLevel
}

const RequiredLevelContent = ({ level }: Props) => {
  return (
    <Stack gap={0.5} p={3} width="100%">
      <Text variant="badge">
        <Localized id={levelTranslation[level]} />
      </Text>
      <Text variant="xsmall">
        <Localized id={levelDescriptionTranslation[level]} />
      </Text>
    </Stack>
  )
}

export default RequiredLevelContent
